export const title = "Ready to hang?";
export const subTitle = "Connect, Celebrate, Cherish. Let's Hang!";

export const groupDescTopGridRow = [
  {
    name: "Diverse Communities 🌐",
    description:
      "Join diverse groups tailored to your interests, from fitness fanatics to book lovers. Discover authentic circles that resonate with your passions and connect with like-minded individuals.",
  },
  {
    name: "Easy Planning 📅",
    description:
      "Effortlessly plan activities and events within your group. Whether it's a casual hangout, game night, or a weekend adventure, coordinating with your buddies has never been simpler.",
  },
];

export const groupDescBottomGridRow = [
  {
    name: "Personalized Touch 🎨",
    description:
      "Personalize your group with emojis and colors to make it uniquely yours. Express your group's personality and create a vibrant space that reflects the shared vibes of your community.",
  },
  {
    name: "Chats 💬",
    description:
      "Foster meaningful connections through dedicated chat channels. Discuss shared interests, coordinate activities, and deepen bonds with friends, all in a clutter-free and engaging chat environment.",
  },
];
